export const CONSTANTS = {
  welcome: "Welcome to Sunculture",
  appTitle: "A data platform by SunCulture",
  marifa: "MAARIFA",
  enterCode: "Enter your login credentials to continue",
  login: "Login",
  isLogging: "Logging in...",
  logout: "Logout",
  permisesDetails: "Premises Details",
  customerProfile: "Customer Profile",
  drawPolygon: 'Analyze',
  layers: "Layers",
  noSelectedPermiseTitle:
    "Please select a permise on the map to get the details ",
  unexpectedError: "Sorry, an unexpected error has occurred.",
  loginError: "Login credentials doesn't match Please try again ",
  oops: "Oops!",
  googleLogin: "Google Login",
  googleLoginDesc: "Use your google login account to autheticate your request to view the field sales",
  filter: "Filters"
};
